import { GroupStudents } from "@/pages/groups/students"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/groepen/$groupId/students/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "groups"),
})

function RouteComponent() {
  const { groupId } = useParams({
    from: "/beheer/groepen/$groupId/students/",
  })

  return <GroupStudents groupId={Number(groupId)} />
}
